<template>
  <div v-cloak>

      <h3 v-if="$route.name == 'CoinClothingTshirt'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) T-Shirt
      </h3>

      <h3 v-if="$route.name == 'CoinClothingHodlTshirt'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) HODL T-Shirt
      </h3>

      <h3 v-if="$route.name == 'CoinClothingLongsleeveTshirt'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) Long Sleeve T-Shirt
      </h3>

      <h3 v-else-if="$route.name == 'CoinClothingDress'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) All-Over Print Dress
      </h3>

      <h3 v-else-if="$route.name == 'CoinClothingHoodie'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) Hoodie
      </h3>

      <h3 v-else-if="$route.name == 'CoinClothingSweatshirt'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) Sweatshirt
      </h3>

      <h3 v-else-if="$route.name == 'CoinClothingMug'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) Coffee Mug
      </h3>

      <h3 v-else-if="$route.name == 'CoinClothingLaptopSleeve'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) Laptop Sleeve (Case)
      </h3>

      <h3 v-else-if="$route.name == 'CoinClothingSticker'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) Kiss Cut Sticker
      </h3>

      <h3 v-else-if="$route.name == 'CoinClothingBackpack'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) Backpack
      </h3>

      <h3 v-else-if="$route.name == 'CoinClothingMask'" >
        {{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) Neck Gaiter
      </h3>

      <span v-if="$route.name == 'CoinClothing'" >
        <h3>{{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) Merchandise</h3>

        <div style="margin-top:-5px;">
          {{ $parent.coins[title].name }} merchandise listed on this page is produced using good quality, highly rated white-label base products. Their simple and timeless design makes Crypto Clothing final products universal - suitable for conferences, work environments, or casual daily wear.
          <span v-if="!available">
            <br><br>
            <b>Products displayed on this page are for inspiration only.</b>
          </span>
          <div style="height:30px;"></div>
        </div>
      </span>

      <div style="height:45px;"></div>


      <!-- T-SHIRT -->
      <CryptoTshirt :coin="title" :available="available" />
      <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>
      
      <span v-if="$route.params.coinId == 'dogecoin'">
        <SingleApocalypseWow @countRefresh="countRefresh" />
        <div v-if="$route.name == 'CoinClothing'"  style="clear:both;height:75px;"></div>
      </span>

      <!-- HODL T-SHIRT -->
      <span v-if="cryptoHodlTshirt.includes(title)">
        <CryptoHodlTshirt :coin="title"  :available="available"/>
        <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>
      </span>

      <!-- LONGSLEEVE T-SHIRT -->
      <crypto-longsleeve-tshirt :coin="title"  :available="available"/>
      <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>

      <!-- HOODIE -->
      <CryptoHoodie :coin="title"  :available="available" />
      <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>

      <!-- SWEATSHIRT -->
      <crypto-sweatshirt :coin="title" :available="available" />
      <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>

      <!-- DRESS -->
      <!-- <div v-if="$route.name != 'CoinClothing'"> -->
        <CryptoDress :coin="title" />
        <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>
      <!-- </div> -->

      <!-- MUG -->
      <CryptoCoffeeMug :coin="title" :available="available" />
      <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>
      
      <!-- LAPTOP SLEEVE -->
      <CryptoLaptopSleeve :coin="title" :available="available" />
      <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>

      <!-- STICKER -->
      <CryptoSticker :coin="title" :available="available" />
      <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>
  
      <!-- BACKPACK -->
      <span v-if="cryptoBackpacks.includes(title)">
        <CryptoBackpack :coin="title"  :available="available"/>
        <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>
      </span>

      <!-- MASK -->
      <span v-if="cryptoMasks.includes(title)">
        <CryptoMask :coin="title"  :available="available"/>
        <div v-if="$route.name == 'CoinClothing'" style="clear:both;height:75px;"></div>
      </span>

      <span v-if="$route.params.coinId == 'bitcoin' && true == false">
        <h3>{{ $parent.coins[title].name }} x AI Artists</h3>
        Generated with artificial intelligence engine DALL-E.
        <br><br>
        <SingleCryptoAI @countRefresh="countRefresh" />
        <div v-if="$route.name == 'CoinClothing'"  style="clear:both;height:75px;"></div>
      </span>
  

      <!-- BACK -->
      <span v-show="individual">

        <div style="clear:both;height:100px;"></div>

        <div style="border-bottom:1px solid #b1b1b1;"></div>

        <div style="clear:both;height:20px;"></div>

        <div>
          Back to <router-link :to="'/'+title" class="underline">{{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) Merchandise</router-link>
        </div>
        
      </span>


      <span v-if="$route.name == 'CoinClothing'">

        <div style="clear:both;height:40px;" class="desktop-spacer"></div>
        <div style="border-bottom:1px solid #b1b1b1;"></div>
        <div style="clear:both;height:20px;"></div>

        <!-- The above presented {{ $parent.coins[title].name }} merchandise is based on the <a v-bind:href="'https://cryptologos.cc/'+$route.params.coinId" target="_blank" class="underline">{{ $parent.coins[title].name }} ({{ $parent.coins[title].symbol }}) logo</a> from the <a href="https://cryptologos.cc/" target="_blank" class="underline">Crypto Logos</a> collection.
        
        <div style="height:40px;"></div>

        <div>
          See more: <router-link to="/" class="underline">All Cryptocurrency Clothing</router-link>
        </div> -->

        
      <div style="height:20px;clear:both;"></div>


      <h3>{{ $parent.coins[$route.params.coinId].name }} ({{ $parent.coins[$route.params.coinId].symbol }}) Crypto Alerts</h3>

      <a href="https://coinwink.com" target="_blank">
        <svg title="Coinwink Crypto Alerts" height="35" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 168.4 61.4" style="enable-background:new 0 0 168.4 61.4;" xml:space="preserve">
        <g>
          <path style="fill:#252525;" d="M78.8,38.2c2.2,0,4.1-0.8,5.4-2.3l-1.6-1.5c-1,1.1-2.2,1.6-3.6,1.6c-2.8,0-4.8-2-4.8-4.8
            c0-2.8,2-4.8,4.8-4.8c1.4,0,2.6,0.5,3.6,1.6l1.6-1.5c-1.3-1.5-3.2-2.3-5.4-2.3c-4.2,0-7.3,2.9-7.3,7C71.6,35.3,74.7,38.2,78.8,38.2
            L78.8,38.2z M91.2,38.2c3.2,0,5.5-2.2,5.5-5.3c0-3.1-2.3-5.3-5.5-5.3c-3.2,0-5.5,2.2-5.5,5.3C85.7,36,88,38.2,91.2,38.2L91.2,38.2z
            M91.2,36.1c-1.7,0-3.1-1.3-3.1-3.2c0-2,1.3-3.2,3.1-3.2c1.8,0,3.1,1.3,3.1,3.2C94.3,34.9,92.9,36.1,91.2,36.1L91.2,36.1z
            M100.8,26c0.9,0,1.5-0.7,1.5-1.5c0-0.8-0.7-1.4-1.5-1.4s-1.5,0.6-1.5,1.5S99.9,26,100.8,26L100.8,26z M99.6,38.1h2.4V27.7h-2.4
            V38.1L99.6,38.1z M111.6,27.6c-1.5,0-2.8,0.5-3.6,1.5v-1.3h-2.3v10.3h2.4v-5.2c0-2.1,1.2-3.1,2.9-3.1c1.5,0,2.5,0.9,2.5,2.7v5.6
            h2.4v-5.9C115.9,29,114.1,27.6,111.6,27.6L111.6,27.6z M133.3,27.7l-2.8,7.7l-2.8-7.7h-2l-2.8,7.6l-2.7-7.6h-2.3l3.8,10.3h2.3
            l2.7-7.1l2.7,7.1h2.3l3.8-10.3H133.3L133.3,27.7z M138.9,26c0.9,0,1.5-0.7,1.5-1.5c0-0.8-0.7-1.4-1.5-1.4c-0.9,0-1.5,0.6-1.5,1.5
            S138,26,138.9,26L138.9,26z M137.7,38.1h2.4V27.7h-2.4V38.1L137.7,38.1z M149.7,27.6c-1.5,0-2.8,0.5-3.6,1.5v-1.3h-2.3v10.3h2.4
            v-5.2c0-2.1,1.2-3.1,2.9-3.1c1.5,0,2.5,0.9,2.5,2.7v5.6h2.4v-5.9C154,29,152.2,27.6,149.7,27.6L149.7,27.6z M165.4,38.1h2.9l-4.7-6
            l4.3-4.3h-2.9l-5,4.6v-8.7h-2.4v14.4h2.4v-2.7l1.8-1.7L165.4,38.1L165.4,38.1z"/>
          <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#FDFF7F;" d="M30.7,0c16.9,0,30.7,13.7,30.7,30.7
            c0,16.9-13.7,30.7-30.7,30.7C13.7,61.4,0,47.6,0,30.7C0,13.7,13.7,0,30.7,0L30.7,0z"/>
          <path style="fill:#1F1F1F;" d="M30.7,6.6c13.3,0,24.1,10.8,24.1,24.1C54.8,44,44,54.8,30.7,54.8c-6.7,0-12.7-2.7-17.1-7.1
            c-4.4-4.4-7.1-10.4-7.1-17.1c0-6.7,2.7-12.7,7.1-17.1C18,9.3,24,6.6,30.7,6.6L30.7,6.6z M39.7,23.6c1.4,0,2.6,1.1,2.6,2.6
            c0,1.4-1.1,2.6-2.6,2.6c-1.4,0-2.6-1.1-2.6-2.6C37.1,24.8,38.3,23.6,39.7,23.6L39.7,23.6z M16.7,27.3l4.1-3.5l0.8-0.7l0.8,0.7
            l4.1,3.5l-1.7,2l-3.3-2.7l-3.3,2.7L16.7,27.3L16.7,27.3z M41,36.2c0,2.8-1.2,5.4-3,7.3c-1.9,1.9-4.4,3-7.3,3c-2.8,0-5.4-1.2-7.3-3
            c-1.9-1.9-3-4.4-3-7.3H23c0,2.1,0.9,4,2.2,5.4c1.4,1.4,3.3,2.2,5.4,2.2c2.1,0,4-0.9,5.4-2.2c1.4-1.4,2.2-3.3,2.2-5.4H41L41,36.2z
            M52.6,30.7c0-12.1-9.8-21.9-21.9-21.9c-6.1,0-11.5,2.5-15.5,6.4c-4,4-6.4,9.5-6.4,15.5s2.5,11.5,6.4,15.5c4,4,9.5,6.4,15.5,6.4
            C42.8,52.6,52.6,42.8,52.6,30.7L52.6,30.7z"/>
        </g>
        </svg>
      </a>

      <div style="height:10px;"></div>
      
      <span v-if="$parent.coins[$route.params.coinId].name == 'Bitcoin'">
        Receive email and SMS <a href="https://coinwink.com" class="underline" target="_blank">Bitcoin (BTC) alerts</a> about important BTC price changes. Setup your own alerts with custom price targets, and safely forget charts - when your defined Bitcoin price threshold is reached, you will be alerted by Coinwink.
      </span>
      <span v-else>
        Receive email and SMS <a :href="'https://coinwink.com/'+$parent.coins[$route.params.coinId].symbol.toLowerCase()" class="underline" target="_blank">{{ $parent.coins[$route.params.coinId].name }} ({{ $parent.coins[$route.params.coinId].symbol }}) crypto alerts</a> about important {{ $parent.coins[$route.params.coinId].symbol }} price changes. Setup your own alerts with custom price targets, and safely forget charts - when your defined {{ $parent.coins[$route.params.coinId].name }} price threshold is reached, you will be alerted by Coinwink.
      </span>
      

      <div style="height:40px;clear:both;"></div>


      </span>

    
  </div>
</template>

<script>
import CryptoTshirt from "../components/CryptoTshirt.vue";
import CryptoSweatshirt from "../components/CryptoSweatshirt";
import CryptoHodlTshirt from "../components/CryptoHodlTshirt.vue";
import CryptoDress from "../components/CryptoDress.vue";
import CryptoHoodie from "../components/CryptoHoodie.vue";
import CryptoLongsleeveTshirt from "../components/CryptoLongsleeveTshirt";
import CryptoCoffeeMug from "../components/CryptoCoffeeMug.vue";
import CryptoLaptopSleeve from "../components/CryptoLaptopSleeve.vue";
import CryptoSticker from "../components/CryptoSticker.vue";
import CryptoMask from "../components/CryptoMask.vue";
import CryptoBackpack from "../components/CryptoBackpack.vue";

import SingleApocalypseWow from "../components/SingleApocalypseWow.vue";
import SingleCryptoAI from "../components/SingleCryptoAI.vue";

export default {
  components: {
    CryptoHodlTshirt,
    CryptoTshirt,
    CryptoLongsleeveTshirt,
    CryptoDress,
    CryptoHoodie,
    CryptoSweatshirt,
    CryptoCoffeeMug,
    CryptoLaptopSleeve,
    CryptoSticker,
    CryptoBackpack,
    CryptoMask,
    SingleApocalypseWow,
    SingleCryptoAI,
  },
  name: 'CoinClothing',
  computed: {

    // myCodeString() {
    //   let coinId = this.$route.params.coinId;
    //   return ('<div><h3>'+this.$parent.coins[$route.params.coinId].name+' ('+this.$parent.coins[$route.params.coinId].symbol+') Merchandise</h3><div style="height:35px;"></div><div style="font-size: 13px;line-height:150%;"><div style="margin-bottom:15px;display:grid;grid-template-columns: 1fr 1fr;grid-column-gap: 15px;max-width:310px;float:left;"><div><a href="https://cryptoclothing.cc/'+coinId+'/t-shirt" target="_blank"><div style="border: 1px solid #b1b1b1;background-color:white;overflow: hidden;border-radius: 5px;max-height:145px;"><img src="https://cryptoclothing.cc/merch/'+coinId+'-'+this.$parent.coins[$route.params.coinId].symbol.toLowerCase()+'-t-shirt.jpg'+this.version+'" style="width:100%;"></div><div style="margin-top:7px;text-align: center;color:#222"><u>'+this.$parent.coins[$route.params.coinId].name+' ('+this.$parent.coins[$route.params.coinId].symbol+')<br>T-Shirt</u></div></a></div>    <div><a href="https://cryptoclothing.cc/'+coinId+'/dress" target="_blank"><div style="border: 1px solid #b1b1b1;background-color:white;overflow: hidden;border-radius: 5px;max-height:145px;"><img src="https://cryptoclothing.cc/merch/'+coinId+'-'+this.$parent.coins[$route.params.coinId].symbol.toLowerCase()+'-dress-front.jpg'+this.version+'" style="width:100%;"></div><div style="margin-top:7px;text-align: center;color:#222"><u>'+this.$parent.coins[$route.params.coinId].name+' ('+this.$parent.coins[$route.params.coinId].symbol+')<br>All-Over Print Dress</u></div></a></div></div><div style="float:left;width:15px;height:5px;"></div><div style="display:grid;grid-template-columns: 1fr 1fr;grid-column-gap: 15px;max-width:310px;margin: 0px 0px 20px 0px;float:left;"><div><a href="https://cryptoclothing.cc/'+coinId+'/hoodie" target="_blank"><div style="border: 1px solid #b1b1b1;background-color:white;overflow: hidden;border-radius: 5px;max-height:145px;"><img src="https://cryptoclothing.cc/merch/'+coinId+'-'+this.$parent.coins[$route.params.coinId].symbol.toLowerCase()+'-hoodie.jpg'+this.version+'" style="width:100%;"></div><div style="margin-top:7px;text-align: center;color:#222"><u>'+this.$parent.coins[$route.params.coinId].name+' ('+this.$parent.coins[$route.params.coinId].symbol+')<br>Hoodie</u></div></a></div><div><a href="https://cryptoclothing.cc/'+coinId+'/coffee-mug" target="_blank"><div style="border: 1px solid #b1b1b1;background-color:white;overflow: hidden;border-radius: 5px;max-height:145px;"><img src="https://cryptoclothing.cc/merch/'+coinId+'-'+this.$parent.coins[$route.params.coinId].symbol.toLowerCase()+'-coffee-mug.jpg'+this.version+'" style="width:100%;"></div><div style="margin-top:7px;text-align:center;color:#222"><u>'+this.$parent.coins[$route.params.coinId].name+' ('+this.$parent.coins[$route.params.coinId].symbol+')<br>Coffee Mug</u></div></a></div></div></div><div style="clear:both;height:18px;"></div><div style="border-bottom:1px solid #b1b1b1;"></div><div style="height:9px;"></div><div style="font-size:13px;line-height:170%;"><a href="https://cryptoclothing.cc/'+coinId+'" target="_blank"><u style="color:#222;">'+this.$parent.coins[$route.params.coinId].name+' ('+this.$parent.coins[$route.params.coinId].symbol+') merchandise</u></a>&nbsp;from&nbsp;<span style="white-space: nowrap;"><a href="https://cryptoclothing.cc/" target="_blank"><svg style="vertical-align:bottom;width:24px;filter:drop-shadow(0 1px 1px rgba(0,0,0,.4));" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.5 67.5"><path d="M9.9 9.9a33.8 33.8 0 1 1 0 47.7 33.8 33.8 0 0 1 0-47.7z" fill="#fdffa3" fill-rule="evenodd"></path><path d="M51.3 51.3a24.7 24.7 0 1 1 0-35m-7.7 27.2a13.8 13.8 0 1 1 0-19.6" fill="none" stroke="#000" stroke-miterlimit="2.6" stroke-width="1.8"></path></svg></a>&nbsp;<a href="https://cryptoclothing.cc/" target="_blank"><span style="font-weight:600;font-size:14px;color:#222;">Crypto Clothing</span></a></span></div></div>');
    // },

    title() {
      // return this.$route.params.coinId.substring(0, this.$route.params.coinId.lastIndexOf("-") + 1);
      return this.$route.params.coinId;
    },

    individual() {   
      if (this.$route.name.substring(0, 12) == 'CoinClothing' && this.$route.name.length > 12) {
        return(true);
      }
    },

  },

  data() {
    return {
      version: '',

      cryptoHodlTshirt: [ 'bitcoin', 'ethereum', 'xrp', 'litecoin', 'stellar', 'monero', 'uniswap', 'yearn-finance' ],
      cryptoBackpacks: ['bitcoin', 'ethereum', 'litecoin', 'eos', 'dash', 'stellar', 'tron', 'cardano', 'nexo', 'request', 'airswap', 'peercoin', 'dragon-coins', 'dragonchain', 'dogecoin'],
      cryptoMasks: ['bitcoin', 'ethereum', 'xrp', 'litecoin', 'binance-coin', 'cardano', 'stellar', 'tron', 'chainlink', 'ethereum-classic', 'insolar', 'ocean-protocol', 'augur', 'dash', 'decentraland', 'dogecoin', 'ethereum-classic', 'foam', 'grin', 'iota', 'monero', 'nexo', 'numeraire', 'power-ledger', 'qtum', 'request'],

      view: '',
      tshirtSize: 'L',
      hoodieSize: 'L',
      mugSize: '11oz',
      dressSize: 'M',
      dressAmount: 1,
      stickerAmount: 1,
      stickerSize: '4x4',
      tshirtAmount: 1,
      hoodieAmount: 1,
      mugAmount: 1,
      complement: '',
      showAddedLinkTshirt: false,
      showAddedLinkDress: false,
      showAddedLinkHoodie: false,
      showAddedLinkMug: false,
      showAddedLinkSticker: false,

      dress2nd: false,
      sticker2nd: false,

      isCopied: false,

      cc_coins_home: cc_coins_home,

      available: false,
    }
  },

  beforeMount() {
    this.version = assetsVersion;
  },

  mounted() {
    
    for (let coin in cc_coins_home) {
      if (cc_coins_home.hasOwnProperty(coin)) {
        // console.log(coin, cc_coins_home[coin]);
        if (coin == this.$route.params.coinId) {
          this.available = false;
        }
      }
    }

  },

  watch:{
   
  },

  methods: {

    copyHtml: function() {
      var text = document.getElementById('cc-html');
      var selection = window.getSelection();
      var range = document.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
      //add to clipboard.
      document.execCommand('copy');
      this.isCopied = true;
    },

    countRefresh() {
      this.$emit('countRefresh');
    }
    
  }
};
</script>

<style>
  .my-code {
    font-family: "SF Mono", "Monaco", "Andale Mono", "Lucida Console", "Bitstream Vera Sans Mono", "Courier New", Courier, monospace;
    color:#005850;
    font-size:12px;
    /* white-space: nowrap; */
  }

  div.my-code-container {
    max-width:100%;
    overflow-x: hidden;
    text-align:left;
    padding: 10px;
    height: 80px;
    background-color:rgb(247, 247, 247);
    border: 1px solid grey;
    border-radius: 5px;
  }

  div.my-code-container::-webkit-scrollbar-track {
    background: #ffffff00;
    border-radius: 5px;
  }
  div.my-code-container::-webkit-scrollbar {
    width: 10px;
  }
  div.my-code-container::-webkit-scrollbar-thumb {
    background: rgb(164, 164, 164);
    border-radius: 5px;
  }

  .product-title {
    font-weight: 600;
    font-size: 1.1em;
  }

  .photo-slider {
    position: absolute;
    width: 35px;
    height: 70px;
    border-top: none;
    border-left: none;
    /* border-right: 1px solid #b9b9b9; */
    border-bottom-right-radius: 5px;
    /* border-bottom: 1px solid #b9b9b9; */
    /* background-color: white; */
    cursor: default;
    z-index:5;
  }

  .photo-slider-btn {
    position:absolute;
    left:8px;
    border-radius:50%;
    cursor: pointer;
    border:1px solid grey;
    width:15px;
    height:15px;
  }

  .photoSliderBtnActive {
    border:2px solid #52a3b5;
    background-color: #a1dbe2;
    width:13px;
    height:13px;
  }

  @media screen and (max-width: 600px) {
    .desktop-spacer {
      height: 0px;
      margin-top: -60px;
    }
  }
</style>